<template>
  <div class="d-flex flex-wrap row-gap-3">
    <span
      v-for="(item, index) in items"
      :key="index"
      class="paragraph-xs font-600 link"
      :class="{ 'text-inactive cursor-auto': activeTab === item.value }"
      @click="activeTab = item.value"
    >
      {{ item.label }}

      <span v-if="index !== items.length - 1" class="mx-4 text-inactive font-400">|</span>
    </span>
  </div>
</template>

<script setup lang="ts" generic="T">
defineProps<{
  items: {
    label: string;
    value: T;
  }[];
}>();

const activeTab = defineModel<T>({ required: true });
</script>

<style scoped lang="scss"></style>
